<template>
  <tr :class="{ 'is-checked': isChecked }" @click.prevent="click">
    <td v-if="hasTaskForm" width="29">
      <Checkbox
        v-if="item.hasError"
        :id="item.category + '_' + item.id"
        :name="item.category + '[]'"
        :value="item"
        :checked="checked"
        ref="checkbox"
        @change="change"
      />
    </td>
    <td width="240" class="l-px-4 l-py-2 c-text--prewrap">{{ item.label }}</td>
    <td class="l-p-0">
      <ListCheckUp
        :detail="item.detail"
        :name="item.id"
        :hasError="item.hasError"
      />
    </td>
    <td width="100" class="c-text--center">
      <div class="c-graph-star">
        <span class="c-graph-star__checked">
          {{ '★' | repeatText(item.score) }}
        </span>
        {{ '★' | repeatText(5 - item.score) }}
      </div>
    </td>
    <td width="75" class="c-text--center">
      <span v-if="!item.hasError" class="c-text--en c-color--positive">OK</span>
      <span v-else class="c-text--en c-color--negative">NG</span>
    </td>
  </tr>
</template>

<script>
import Checkbox from '@/components/Checkbox';
import ListCheckUp from '@/components/seo/ListCheckUp';

export default {
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    checked: {
      type: Array,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    hasTaskForm: {
      type: Boolean,
      required: true
    }
  },
  components: {
    Checkbox,
    ListCheckUp
  },
  computed: {
    isChecked() {
      return this.checked.includes(this.item);
    }
  },
  methods: {
    change(checked) {
      this.$emit('change', checked);
    },
    click() {
      if (!this.item.hasError) {
        return;
      }
      this.$refs.checkbox.change();
    }
  }
};
</script>
